/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeviceIntegrationProviderField,
  DeviceIntegrationProviderField$inboundSchema,
} from "./deviceintegrationproviderfield.js";
import {
  DeviceIntegrationProviderSchedule,
  DeviceIntegrationProviderSchedule$inboundSchema,
} from "./deviceintegrationproviderschedule.js";

/**
 * A vendor the device integrations framework can connect to.
 */
export type DeviceIntegrationProvider = {
  /**
   * Integration directions the provider supports: inventory_source (pull the managed-device fleet) and/or evidence_sink (push agent-coverage evidence).
   */
  capabilities: Array<string>;
  /**
   * Human-readable vendor name.
   */
  displayName: string;
  /**
   * Credential and settings inputs the provider needs, in render order.
   */
  fields: Array<DeviceIntegrationProviderField>;
  /**
   * Provider identifier (e.g. jamf, kandji, drata, vanta).
   */
  id: string;
  /**
   * Sync pipelines the provider runs.
   */
  schedules: Array<DeviceIntegrationProviderSchedule>;
};

/** @internal */
export const DeviceIntegrationProvider$inboundSchema: z.ZodMiniType<
  DeviceIntegrationProvider,
  unknown
> = z.pipe(
  z.object({
    capabilities: z.array(z.string()),
    display_name: z.string(),
    fields: z.array(DeviceIntegrationProviderField$inboundSchema),
    id: z.string(),
    schedules: z.array(DeviceIntegrationProviderSchedule$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
    });
  }),
);

export function deviceIntegrationProviderFromJSON(
  jsonString: string,
): SafeParseResult<DeviceIntegrationProvider, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceIntegrationProvider$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceIntegrationProvider' from JSON`,
  );
}
